import axios from "axios";
import toast from "react-hot-toast";
import { LStorage } from "../config/constants";

export const api = axios.create({
  responseType: "json",
});

let store;

export const injectStore = (_store) => {
  store = _store;
};

const feedbackExceptionUrl = "/Feedback/Status/";
const questionExceptionUrl = "/Question";
const feedbackDetailHistoryExceptionUrl = "/Feedback/Logs/";
const customerExceptionUrl = "/Customer";
const dashboardDataUrl = "Dashboard/Data";

api.interceptors.request.use(
  async (config: any) => {
    config.headers = {
      "Content-Type": "application/json",
      ...config.headers,
      // languageId: localStorage.getItem(LStorage.LANG) || "",
      languageId: "2",
      Authorization: localStorage.getItem(LStorage.AUTH) || "",
    };
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response.data,
  (err) => {
    const msg = err?.response?.data?.error?.message.slice(0, 100)
    if (err.response.status === 401) {
      // localStorage.removeItem(LStorage.AUTH);
      // window.location.href = "/login";
    }

    return new Promise(async (_, reject) => {
      const t =
        store.getState()?.translations?.translationDataByLangId?.translations;
      if (
        err?.response?.config?.url.includes(feedbackExceptionUrl) ||
        err?.response?.config?.url.includes(questionExceptionUrl) ||
        err?.response?.config?.url.includes(
          feedbackDetailHistoryExceptionUrl
        ) ||
        err?.response?.config?.url.includes(customerExceptionUrl)
      ) {
        return reject(err);
      }
      if (err?.response?.config?.url.includes(dashboardDataUrl)) {
        toast.error(
          msg
            ? `${msg}`
            : t?.["statistical_data_not_found"]
        );
        return reject(err);
      }
      if (msg) {
        toast.error(
          t?.[`${msg}`] ||
            `${msg}`
        );
        reject(err);
      } else {
        toast.error("SMT Went Wrong");
        reject(err);
      }
    });
  }
);
